import {GetBannersV2Request} from 'domain/usecases/private/home/banners-v2';
import {makeGetBannersV2} from 'main/factories/usecases';

export const getBannersV2 = async (params: GetBannersV2Request) => makeGetBannersV2().post(params);
